import { useMemo, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { getQueryClientConfig } from "./process/getQueryClientConfig";

import type { QueryClientConfig } from "@tanstack/react-query";
import type { FC, ReactNode } from "react";

export interface QueryProviderProps {
    children: ReactNode;
    client?: QueryClient;
    config?: QueryClientConfig;
}

export const QueryProvider: FC<QueryProviderProps> = ({ children, client, config }) => {
    const queryClientConfig = useMemo(() => getQueryClientConfig(config), [config]);

    const [queryClient] = useState(() => client ?? new QueryClient(queryClientConfig));

    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
